import { CommonModule } from '@angular/common'
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core'
import { MessageService } from 'primeng/api'
import { SearchComponent } from 'src/app/shared/components/search/search.component'
import { LoadingIndicatorComponent } from 'src/app/shared/components/ui/loading-indicator/loading-indicator.component'
import { finalize } from 'rxjs'
import { RecommendedPricingService } from '../recommended-prices/services/recommended-pricing.service'
import { RecommendedPricesLiveQuotesTableComponent } from '../recommended-prices/live-quotes-table/table.component'
import { CardModule } from 'primeng/card'
import { KeyMetricsLiveQuotesTableComponent } from './live-quotes-table/table.component'
import { RadioButtonModule } from 'primeng/radiobutton'
import { FormsModule } from '@angular/forms'
import { KeyMetricsService } from './services/key-metrics.service'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { Router } from '@angular/router'

@Component({
  selector: 'app-key-metrics',
  template: `
    <!-- <app-loading-indicator *ngIf="loading"></app-loading-indicator> -->
    <!-- <div class="flex flex-wrap gap-3" style="padding: 1rem">
      <div class="flex align-items-center" style="margin-right: 2rem;">
        <span style="color: #641E8C; font-weight: 700">Displayed time frame</span>
      </div>
      <div class="flex align-items-center">
          <p-radioButton name="all" value="all" [(ngModel)]="ingredient" inputId="all"></p-radioButton>
          <label for="ingredient1" class="ml-2">All</label>
      </div>

      <div class="flex align-items-center">
          <p-radioButton name="currentYear" value="currentYear" [(ngModel)]="ingredient" inputId="currentYear"></p-radioButton>
          <label for="currentYear" class="ml-2">This year</label>
      </div>

      <div class="flex align-items-center">
          <p-radioButton name="6months" value="6months" [(ngModel)]="ingredient" inputId="6months"></p-radioButton>
          <label for="6months" class="ml-2">Last 6 months</label>
      </div>

      <div class="flex align-items-center">
          <p-radioButton name="lastYear" value="lastYear" [(ngModel)]="ingredient" inputId="lastYear"></p-radioButton>
          <label for="lastYear" class="ml-2">Last year</label>
      </div>
      <div class="flex align-items-center">
          <p-radioButton name="last2Years" value="last2Years" [(ngModel)]="ingredient" inputId="last2Years"></p-radioButton>
          <label for="last2Years" class="ml-2">Last 2 years</label>
      </div>
    </div> -->
    <div class="container-stats">
      <div class="first" style=" width:100%; overflow:auto; border-radius: 0.325rem">
        <div
          class="flex flex-row stats-cards"
          style="display: flex; flex-direction: row; gap:2rem;">
          <div>
            <h2 style="color: #B96CFF; margin-bottom: 2rem">Live Quotes</h2>
            <div style="display: flex; flex-direction: row; gap:1rem;">
              <p-card
                header="Number of Live Quotes"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">{{ metrics?.live_qoutes_size }}</p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
              <p-card
                header="Number of Quote Line items"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">{{ metrics?.total_line_item }}</p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
              <p-card
                header="Unique Materials in Live Quotes"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">{{ metrics?.total_unique_material }}</p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
            </div>
          </div>
          <div style="padding-right: 1rem">
            <h2
              style="color: #B96CFF; margin-bottom: 2rem
">
              Recommended Prices
            </h2>
            <div style="display: flex; flex-direction: row; gap:1rem; ">
              <p-card
                header="Price Coverage based on line Item"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">
                  {{ metrics?.coverge_line_item_mapped | number : '1.2-2' }}
                </p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
              <p-card
                header="Price Coverage based on Unique Material"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">
                  {{
                    metrics?.coverage_unique_material_mapped | number : '1.2-2'
                  }}
                </p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
              <p-card
                header="incremental Revenue"
                [style]="{ 'min-width': '16rem' }">
                @if (!loadingMetrics) {
                <!-- <p class="m-0 text-small-roman">May 2024</p> -->
                <p class="m-0 text-big">
                  {{ metrics?.incremental_revenue | number : '1.2-2' }}
                </p>
                } @else {
                <div *ngIf="loadingMetrics">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                }
                <div
                  style="display: flex;     justify-content: space-between;
    align-items: center;">
                  <!-- <span class="text-small-roman">Update 23.01.2023</span> -->
                </div>
              </p-card>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="second">
        <div style="display: flex; gap:0.3rem">
          <span class="text-default-strong-bold" style="color: #641E8C"
            >Usage Statistics</span
          >
          <span
            class="text-default-strong-bold"
            style="font-weight: 400;color: #641E8C"
            >Strategic Pricing tool</span
          >
        </div>
        <div class="statistics-row">
          <span style="color: #5F5F5F;">Log ins</span>
          <span class="h4">250</span>
        </div>
        <div class="statistics-row">
          <span style="color: #5F5F5F;">Active users</span>
          <span class="h4">250</span>
        </div>
        <div class="statistics-row">
          <span style="color: #5F5F5F;">Average time spent in minutes</span>
          <span class="h4">250</span>
        </div>
      </div>
    </div> -->
      <div style="padding: 1rem; width: 100%">
        <app-recommended-prices-live-quotes-table
          [loading]="loading"
          (quoteClicked)="handleQuoteClicked($event)"
          [tableData]="liveQuotesTableData"
          [quoteId]="tableTitle"></app-recommended-prices-live-quotes-table>
      </div>
    </div>
  `,
  styles: [
    `
      .stats-cards {
        & .p-card {
          height: 100%;

          &-title {
            color: #212529;
            font-family: 'Siemens Sans', sans-serif;
            font-size: 1rem;
            font-style: normal;
            font-weight: 700;
            line-height: 1.375rem; /* 157.143% */
            letter-spacing: 0.0125rem;
          }
          &-body {
            padding: 0.74rem 1rem;
          }

          &-content {
            padding: 0;
          }
        }
      }
      .container-stats {
        display: flex;
        flex-wrap: wrap;
      }
      .first {
        background: #1b1534;
        padding: 1rem;
        margin: 1rem;
        flex-grow: 1;
        flex-basis: 75%;
      }
      .second {
        margin: 1rem;
        border: 1px solid #dedede;
        flex-grow: 1;
        flex-basis: 20%;
        padding: 1rem;
      }
      @media (max-width: 500px) {
        .first,
        .second {
          flex-basis: 100%;
        }
      }
      .statistics-row {
        padding: 1rem 0rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #dedede;
        align-items: baseline;
      }
      .flex {
        display: flex;
      }
      .gap-3 {
        gap: 3rem;
      }
      .ml-2 {
        margin-left: 1rem;
      }
    `,
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    SearchComponent,
    LoadingIndicatorComponent,
    RecommendedPricesLiveQuotesTableComponent,
    CardModule,
    KeyMetricsLiveQuotesTableComponent,
    RadioButtonModule,
    FormsModule,
    ProgressSpinnerModule,
  ],
})
export class KeyMetricsComponent implements OnInit {
  isDataAvailable = false
  tableTitle = ''
  liveQuotesTableData!: any[]
  quotesTableData!: any[]
  loading = false
  materialOptions = [{ name: 'Quote Number', code: 'quoteId' }]
  selectedMaterialOption = { name: 'Quote Number', code: 'quoteId' }
  ingredient!: string
  metrics!: any
  loadingMetrics = false

  private messageService = inject(MessageService)
  private recommendedPricingService = inject(RecommendedPricingService)
  private keyMetricsService = inject(KeyMetricsService)

  constructor(private router: Router){}

  ngOnInit(): void {
    this.getLiveQuotes()
    this.getMetrics()
  }

  handleSearch(query: any) {
    this.getQuoteLine(query.searchValue)
    this.tableTitle = query.searchValue
  }

  handleQuoteClicked(quote: any) {
    /* this.tableTitle = quote.NAME
    this.getQuoteLine(quote.NAME) */

    this.router.navigate(['/recommended-prices'], 
      {
        queryParams: {
          quoteNumber: quote.NAME
        }
      }
    )
  }

  getQuoteLine(liveQuoteId: string) {
    this.loading = true
    this.quotesTableData = []

    this.isDataAvailable = true

    this.recommendedPricingService
      .getQuoteLine(liveQuoteId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result: any) => {
          this.quotesTableData = result
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while processing your request.',
          })
        },
      })
  }

  getLiveQuotes() {
    this.loading = true
    this.liveQuotesTableData = []

    this.isDataAvailable = true

    this.recommendedPricingService
      .getLiveQuotes()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result: any) => {
          this.liveQuotesTableData = result.map(
            (item: {
              CREATEDDATE: string | number | Date
              SUBMITTEDDATE__C: string | number | Date
            }) => ({
              ...item,
              CREATEDDATE: new Date(item.CREATEDDATE),
              SUBMITTEDDATE__C: new Date(item.SUBMITTEDDATE__C),
            })
          )

          console.log(this.liveQuotesTableData)

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while processing your request.',
          })
        },
      })
  }

  getMetrics() {
    this.loadingMetrics = true
    this.keyMetricsService
      .getMetrics()
      .pipe(finalize(() => (this.loadingMetrics = false)))
      .subscribe({
        next: (result: any) => {
          console.log(result)
          this.metrics = result

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while processing your request.',
          })
        },
      })
  }
}
